import { CURRENT_ID_ROLE_STORAGE } from "@/constants/commons";

export const getCurrentIdRoleFromSessionStorage = (): number =>{
  const currentIdRole = sessionStorage.getItem(CURRENT_ID_ROLE_STORAGE);
  if (currentIdRole === null) {
    return Number.NaN;
  }
  return Number(currentIdRole);
}

export const setCurrentIdRoleToSessionStorage = (idRole: number): void => {
  sessionStorage.setItem(CURRENT_ID_ROLE_STORAGE, String(idRole ?? ""));
}

export const clearCurrentIdRoleToSessionStorage = (): void => {
  sessionStorage.removeItem(CURRENT_ID_ROLE_STORAGE);
}

export const clearSesionStorage = (): void => {
  sessionStorage.clear();
}